export const AUTO_OPEN_LINKEDIN_KEY = 'autoOpenLinkedin';
export const ENABLE_EVERYWHERE_KEY = 'enableEverywhere';
export const ENABLE_TOOLS_KEY = 'enableCalendar';
export const OPENED_CALENDAR_KEY = 'openedCalendar';
export const ENABLE_CRM_KEY = 'enableCrm';
export const ENABLE_GCALENDAR_KEY = 'enableGoogleCalendar';
export const ENABLE_GMAIL_KEY = 'enableGmail';

export type SettingsKey =
  | typeof AUTO_OPEN_LINKEDIN_KEY
  | typeof ENABLE_EVERYWHERE_KEY
  | typeof ENABLE_TOOLS_KEY
  | typeof ENABLE_CRM_KEY
  | typeof ENABLE_GCALENDAR_KEY
  | typeof ENABLE_GMAIL_KEY;

export type SettingKeysWithDisabledPage =
  | typeof ENABLE_CRM_KEY
  | typeof ENABLE_TOOLS_KEY
  | typeof ENABLE_GCALENDAR_KEY
  | typeof ENABLE_GMAIL_KEY;

export type SettingsAppStorage = {
  [AUTO_OPEN_LINKEDIN_KEY]?: boolean;
  [ENABLE_EVERYWHERE_KEY]?: boolean;
  [ENABLE_TOOLS_KEY]?: boolean;
  [ENABLE_CRM_KEY]?: boolean;
  [OPENED_CALENDAR_KEY]?: boolean;
  [ENABLE_GCALENDAR_KEY]?: boolean;
  [ENABLE_GMAIL_KEY]?: boolean;
  hasApprovedTerms?: boolean;
  isCustomUiVersion?: boolean;
  uiVersion?: string | null;
  shouldEnableToggle?: SettingsKey;
  isFirstOpen?: boolean;
  isFirstOpenedAfterPurchase?: boolean;
  tabUpdateConfig?: {
    pagesToTrack: string[];
  };
  settingsWereSet?: boolean;
  hasNotifiedAdminForQuota?: boolean;
};

export const isAppSettingsKey = (key: string): boolean => {
  return (
    [
      AUTO_OPEN_LINKEDIN_KEY,
      ENABLE_EVERYWHERE_KEY,
      ENABLE_TOOLS_KEY,
      ENABLE_CRM_KEY,
      OPENED_CALENDAR_KEY,
      ENABLE_GCALENDAR_KEY,
      ENABLE_GMAIL_KEY,
      'hasApprovedTerms',
      'isCustomUiVersion',
      'uiVersion',
      'shouldEnableToggle',
      'isFirstOpen',
      'isFirstOpenedAfterPurchase',
      'tabUpdateConfig',
      'hasNotifiedAdminForQuota',
    ].includes(key) || key.startsWith('hasRequestedAccess-')
  );
};
